// removed by extract-text-webpack-plugin
module.exports = {"root":"MetropolisNonLoggedBG__root___2bjVi"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/metropolis/components/NonLoggedBG/MetropolisNonLoggedBG.scss
// module id = 2231
// module chunks = 0